import { Modal } from "antd";
import ListComponent from "./history-list";

export const ProcessHistoryModal = (props: any) => {
  const { id, isOpen, onClose, historyData } = props;

  const data = historyData
    .map((e: any) => {
      const {
        AppAuthorLookupId,
        AppEditorLookupId,
        Attachments,
        AuthorLookupId,
        Created,
        Edit,
        EditorLookupId,
        FolderChildCount,
        ItemChildCount,
        Modified,
        _ComplianceFlags,
        _ComplianceTag,
        _ComplianceTagUserId,
        _ComplianceTagWrittenTime,
        _UIVersionString,
        ...fields
      } = e.fields;
      return {
        version: e.id,
        modifier: { ...e.lastModifiedBy.user, date: e.fields.Modified },
        ...fields,
      };
    })
    .sort((a: any, b: any) => +a.version - +b.version);

  let firstVersion = data.length > 0 ? { ...data[0] } : {};

  const compareVersions = (version: any, previosVersion: any) => {
    if (version.version === previosVersion.version) {
      return null;
    }

    const fieldsChange: any = {};

    for (const field in version) {
      if (version[field] !== previosVersion[field]) {
        fieldsChange[field] = version[field];
      }
    }

    return fieldsChange;
  };

  const getDiffVersion = () => {
    const fieldsChange: any[] = [];

    const first = {
      version: firstVersion.version,
      modifier: firstVersion.modifier,
      title: "Tạo phiếu",
      eApprovedBy: firstVersion.eApprovedBy,
      eApprovedByITLead: firstVersion.eApprovedByITLead,
      eAssignee: firstVersion.eAssignee,
    };

    fieldsChange.push(first);

    for (const obj of data) {
      const res = compareVersions(obj, firstVersion);
      if (res) fieldsChange.push(res);
      firstVersion = { ...obj };
    }

    return fieldsChange.sort((a: any, b: any) => +b.version - +a.version);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <Modal
        title={"Lịch sử chỉnh sửa phiếu số: " + id}
        cancelText="Đóng"
        open={isOpen}
        okButtonProps={{ hidden: true }}
        onCancel={handleCancel}
        width={1000}
        bodyStyle={{
          overflow: "auto",
          maxHeight: "70vh"
        }}
      >
        <ListComponent dataSource={getDiffVersion()} />
      </Modal>
    </>
  );
};
